import { Component, Input } from '@angular/core';
var MessageBoxComponent = /** @class */ (function () {
    function MessageBoxComponent() {
    }
    /**
     * Implementation of Angular's OnInit lifecycle hook
     */
    MessageBoxComponent.prototype.ngOnInit = function () { };
    MessageBoxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-message-box',
                    template: "<div class=\"a-message-box {{ modifier && 'a-message-box--' + modifier || modifier }}\" data-t-name=\"MessageBox\" [innerHTML]=\"message\">\r\n\t\r\n</div>"
                }] }
    ];
    /** @nocollapse */
    MessageBoxComponent.ctorParameters = function () { return []; };
    MessageBoxComponent.propDecorators = {
        modifier: [{ type: Input }],
        message: [{ type: Input }]
    };
    return MessageBoxComponent;
}());
export { MessageBoxComponent };
//# sourceMappingURL=message-box.component.js.map